module.exports = __webpack_public_path__ + "static/media/pass_warning.e58437fd.svg";